import api from '../library/axios';
import config from '../config';

export default {
  detail(meeting_id) {
    return api({
      method: 'GET',
      baseURL: config.api.vCallUrl,
      url: `/api/participant/${meeting_id}`,
    });
  },
  join({ meeting_id, data }) {
    return api({
      method: 'POST',
      baseURL: config.api.vCallUrl,
      url: `/api/participant/${meeting_id}`,
      data,
    });
  },
  leave(meeting_id, participant_id) {
    return api({
      method: 'PATCH',
      baseURL: config.api.vCallUrl,
      url: `/api/participant/${meeting_id}/${participant_id}`,
    });
  },
  participant(meeting_id, participant_id) {
    return api({
      method: 'GET',
      baseURL: config.api.vCallUrl,
      url: `/api/participant/${meeting_id}/${participant_id}`,
    });
  },
};
